
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/my-plan",
      function () {
        return require("private-next-pages/my-plan.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/my-plan"])
      });
    }
  